import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Button from '../../../../../shared/_TBComponents/Button';
import Modal from '../../../../../shared/_TBComponents/Modal';
import Text from '../../../../../shared/_TBComponents/Text';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100%;
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const CloseX = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
  color: #9E9E9E;
  padding: 0 2px;
  flex-shrink: 0;

  &:hover { color: #444444; }
  &:focus-visible { outline: 2px solid #1787FB; outline-offset: 2px; }
`;

const ExportBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ExportDataModal = ({
  isOpen, onClose, onExportXLSX, onExportXLS, onExportCSV,
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onClose}
    customBorderRadius='8px'
    customPadding='24px'
    customMaxWidth='400px'
    customMinHeight='200px'
  >
    <ContentWrapper>
      <Header>
        <Text styledTextProps={{ fontSize: '18px', fontWeight: 600, color: '#1A1A1A' }}>
          Export Data
        </Text>
        <CloseX type='button' onClick={onClose} aria-label='Close'>×</CloseX>
      </Header>
      <Text styledWrapperProps={{ marginBottom: '24px' }}>
        Export the currently visible list by clicking a file type below.
      </Text>
      <ExportBody>
        <Button
          name='XLSX'
          fullWidth
          bgColor='#1A1A1A'
          borderColor='#1A1A1A'
          txtColor='#FFF'
          customBorderRadius='6px'
          styledTextProps={{ fontWeight: 600 }}
          onClick={onExportXLSX}
        />
        <Button
          name='XLS'
          fullWidth
          bgColor='#1A1A1A'
          borderColor='#1A1A1A'
          txtColor='#FFF'
          customBorderRadius='6px'
          styledTextProps={{ fontWeight: 600 }}
          onClick={onExportXLS}
        />
        <Button
          name='CSV'
          fullWidth
          bgColor='#1A1A1A'
          borderColor='#1A1A1A'
          txtColor='#FFF'
          customBorderRadius='6px'
          styledTextProps={{ fontWeight: 600 }}
          onClick={onExportCSV}
        />
      </ExportBody>
    </ContentWrapper>
  </Modal>
);

ExportDataModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onExportXLSX: PropTypes.func.isRequired,
  onExportXLS: PropTypes.func.isRequired,
  onExportCSV: PropTypes.func.isRequired,
};

export default ExportDataModal;
